import flow from 'lodash/flow';

import { ErrorType } from '@portal/api-models';
import { getPortalError } from '@portal/common';
import { redact } from '@portal/common/dist/logging/utils';

import type { Logger } from '@/utils/logger/logger';

const redirectDeactivatedUserInterceptor = async (err: unknown) => {
  const { customError } = getPortalError(err);

  if (
    typeof window !== 'undefined' &&
    customError === ErrorType.deactivatedUser
  ) {
    window.location.href = '/deactivated';
  }

  return Promise.reject(err);
};

const logErrorInterceptor = (err: unknown, logger: Logger) => {
  const redactedError = redact(err);
  // Log only the redacted error
  logger.error(redactedError);
  // Return the original error for the app to continue to use
  return err;
};

export const createErrorInterceptor =
  (logger: Logger) => async (err: unknown) =>
    flow(logErrorInterceptor, redirectDeactivatedUserInterceptor)(err, logger);
